export const completeTranslations = {
  fr: {
    // Common
    'common.error': 'Erreur',
    'common.saved': 'a été sauvegardé',
    
    // Header
    'header.hello': 'Bonjour',
    'header.your_orders': 'Vos commandes',
    'header.your_account': 'Votre compte',
    'header.vendor_account': 'Compte vendeur',
    'header.vendor_dashboard': 'Compte vendeur',
    'header.admin_panel': 'Administration',
    'header.administration': 'Administration',
    'header.relay_management': 'Gestion des relais',
    'header.relay_dashboard': 'Gestion des relais',
    'header.create_business': 'Créer mon entreprise',
    'header.logout': 'Déconnexion',
    'header.points': 'Points Relais',
    'header.cart': 'Panier',
    'header.search.placeholder': 'Rechercher un produit...',

    // Admin
    'admin.title': 'Administration',
    'admin.subtitle': 'Tableau de bord administrateur',
    'admin.system_operational': 'Système opérationnel',
    'admin.tabs.dashboard': 'Tableau de bord',
    'admin.tabs.users': 'Utilisateurs',
    'admin.tabs.vendors': 'Vendeurs',
    'admin.tabs.employees': 'Employés',
    'admin.tabs.relays': 'Points relais',
    'admin.tabs.orders': 'Commandes',
    'admin.tabs.cms': 'CMS',
    'admin.tabs.config': 'Configuration',

    'admin.analytics.users': 'Utilisateurs',
    'admin.analytics.vendors': 'Vendeurs',
    'admin.analytics.orders': 'Commandes',
    'admin.analytics.revenue': 'Revenus',
    'admin.analytics.relays': 'Points relais',
    'admin.analytics.employees': 'Employés',

    // Employee/Users Management
    'employee.management': 'Gestion des utilisateurs',
    'employee.total_users': 'Total utilisateurs',
    'employee.active': 'Actifs',
    'employee.suspended': 'Suspendus',
    'employee.administrators': 'Administrateurs',
    'employee.user_list': 'Liste des utilisateurs',
    'employee.user': 'Utilisateur',
    'employee.role': 'Rôle',
    'employee.status': 'Statut',
    'employee.actions': 'Actions',
    'employee.no_name': 'Sans nom',
    'employee.no_phone': 'Pas de téléphone',
    'employee.client': 'Client',
    'employee.admin': 'Administrateur',
    'employee.super_admin': 'Super Admin',
    'employee.vendor': 'Vendeur',
    'employee.relay': 'Point relais',

    // Vendor Management
    'vendor.management': 'Gestion des vendeurs',
    'vendor.manage_vendors': 'Gérer les vendeurs',
    'vendor.tabs.applications': 'Candidatures',
    'vendor.tabs.vendors': 'Vendeurs',
    'vendor.tabs.products': 'Produits',
    'vendor.tabs.analytics': 'Analytics',
    'vendor.tabs.managers': 'Gestionnaires',
    'vendor.applications': 'Candidatures vendeurs',
    'vendor.vendor_list': 'Liste des vendeurs',
    'vendor.candidate': 'Candidat',
    'vendor.company': 'Entreprise',
    'vendor.type': 'Type',
    'vendor.examine': 'Examiner',
    'vendor.product': 'Produit',
    'vendor.vendor': 'Vendeur',
    'vendor.stock': 'Stock',
    'vendor.creation_date': 'Date de création',

    // Configuration
    'admin.config.categories.general': 'Général',
    'admin.config.categories.general_desc': 'Paramètres généraux du site',
    'admin.config.site_info': 'Informations du site',
    'admin.config.site_name': 'Nom du site',
    'admin.config.platform_name': 'Le nom principal de votre plateforme',
    'admin.config.tagline': 'Slogan',
    'admin.config.tagline_desc': 'Description courte de votre plateforme',
    'admin.config.description': 'Description',
    'admin.config.description_desc': 'Description détaillée pour le SEO',
    'admin.config.logo_images': 'Logo et images',
    'admin.config.logo_url': 'Logo du site',
    'admin.config.logo_url_desc': 'URL du logo (laissez vide pour utiliser l\'icône par défaut)',
    'admin.config.hero_image': 'Image de la section hero',
    'admin.config.hero_image_desc': 'URL de l\'image principale de la page d\'accueil',
    'admin.config.contact_support': 'Contact et support',
    'admin.config.contact_email': 'Email de contact',
    'admin.config.contact_email_desc': 'Adresse email principale',
    'admin.config.support_phone': 'Téléphone support',
    'admin.config.support_phone_desc': 'Numéro de téléphone du support client',
    'admin.config.maintenance_mode': 'Mode maintenance',
    'admin.config.maintenance_mode_desc': 'Activer le mode maintenance du site',
    'admin.config.show_announcement_banner': 'Afficher le bandeau d\'annonce',
    'admin.config.show_announcement_banner_desc': 'Affiche ou masque le bandeau orange en haut du site (actif même en mode maintenance)',
    'admin.config.password_reset_expiry': 'Expiration lien réinitialisation',
    'admin.config.password_reset_expiry_desc': 'Durée de validité des liens de réinitialisation de mot de passe (en minutes, entre 5 et 1440)',
    'admin.config.footer': 'Bas de page (Footer)',
    'admin.config.footer_address': 'Adresse',
    'admin.config.footer_address_desc': 'Adresse à afficher dans le footer',
    'admin.config.footer_copyright': 'Texte copyright',
    'admin.config.footer_copyright_desc': 'Texte de copyright en bas de page',
    'admin.config.footer_facebook': 'Lien Facebook',
    'admin.config.footer_facebook_desc': 'URL de votre page Facebook',
    'admin.config.footer_twitter': 'Lien Twitter/X',
    'admin.config.footer_twitter_desc': 'URL de votre compte Twitter',
    'admin.config.footer_instagram': 'Lien Instagram',
    'admin.config.footer_instagram_desc': 'URL de votre compte Instagram',
    'admin.config.appearance': 'Apparence',
    'admin.config.appearance_desc': 'Personnaliser l\'apparence',
    'admin.config.theme_colors': 'Thème et couleurs',
    'admin.config.primary_color': 'Couleur primaire',
    'admin.config.primary_color_desc': 'Couleur principale de votre marque',
    'admin.config.secondary_color': 'Couleur secondaire',
    'admin.config.secondary_color_desc': 'Couleur secondaire pour les accents',
    'admin.config.dark_mode': 'Mode sombre',
    'admin.config.dark_mode_desc': 'Permettre le basculement en mode sombre',
    'admin.config.ui': 'Interface utilisateur',
    'admin.config.border_radius': 'Rayon des bordures',
    'admin.config.border_radius_desc': 'Ajuster l\'arrondi des éléments (px)',
    'admin.config.animation_speed': 'Vitesse d\'animation',
    'admin.config.animation_speed_desc': 'Vitesse des transitions (ms)',
    'admin.config.payment': 'Paiements',
    'admin.config.payment_desc': 'Configuration des paiements',
    'admin.config.payment_methods': 'Méthodes de paiement',
    'admin.config.stripe_enabled': 'Stripe activé',
    'admin.config.stripe_enabled_desc': 'Activer les paiements par carte Stripe',
    'admin.config.mobile_money': 'Mobile Money',
    'admin.config.mobile_money_desc': 'Activer les paiements mobile money',
    'admin.config.cash_on_delivery': 'Paiement à la livraison',
    'admin.config.cash_on_delivery_desc': 'Permettre le paiement à la réception',
    'admin.config.fees': 'Configuration des frais',
    'admin.config.transaction_fee': 'Frais de transaction (%)',
    'admin.config.transaction_fee_desc': 'Pourcentage prélevé sur chaque vente',
    'admin.config.min_order': 'Montant minimum de commande',
    'admin.config.min_order_desc': 'Montant minimum pour passer commande (CDF)',
    'admin.config.payment_simulation': 'Simulation des paiements (test)',
    'admin.config.payment_country_simulation_enabled': 'Activer la simulation de pays',
    'admin.config.payment_country_simulation_enabled_desc': 'Force un pays de test pour le routage paiement (admin uniquement)',
    'admin.config.payment_country_simulation_country': 'Pays simulé',
    'admin.config.payment_country_simulation_country_desc': 'Choisir le pays à simuler (ex: CD pour tester Flutterwave)',
    'admin.config.shipping': 'Livraison',
    'admin.config.shipping_desc': 'Paramètres de livraison',
    'admin.config.shipping_options': 'Options de livraison',
    'admin.config.default_shipping_cost': 'Coût de livraison par défaut',
    'admin.config.default_shipping_cost_desc': 'Prix standard de livraison (CDF)',
    'admin.config.free_shipping_threshold': 'Seuil livraison gratuite',
    'admin.config.free_shipping_threshold_desc': 'Montant pour livraison gratuite (CDF)',
    'admin.config.delivery_days': 'Délai de livraison estimé',
    'admin.config.delivery_days_desc': 'Nombre de jours pour la livraison standard',
    'admin.config.notifications': 'Notifications',
    'admin.config.notifications_desc': 'Gérer les notifications',
    'admin.config.email_notifications': 'Notifications email',
    'admin.config.email_enabled': 'Notifications email',
    'admin.config.email_enabled_desc': 'Envoyer des notifications par email',
    'admin.config.order_confirmation': 'Confirmation de commande',
    'admin.config.order_confirmation_desc': 'Email de confirmation après commande',
    'admin.config.shipping_notification': 'Notification d\'expédition',
    'admin.config.shipping_notification_desc': 'Email lors de l\'expédition',
    'admin.config.sms_notifications': 'Notifications SMS',
    'admin.config.sms_enabled': 'Notifications SMS',
    'admin.config.sms_enabled_desc': 'Envoyer des notifications par SMS',
    'admin.config.security': 'Sécurité',
    'admin.config.security_desc': 'Paramètres de sécurité',
    'admin.config.authentication': 'Authentification',
    'admin.config.email_verification': 'Vérification email obligatoire',
    'admin.config.email_verification_desc': 'Obliger la vérification d\'email à l\'inscription',
    'admin.config.password_length': 'Longueur minimale mot de passe',
    'admin.config.password_length_desc': 'Nombre minimum de caractères',
    'admin.config.session_timeout': 'Timeout de session (minutes)',
    'admin.config.session_timeout_desc': 'Durée avant déconnexion automatique',
    'admin.config.save_all': 'Sauvegarder tous les paramètres',
    'admin.config.reset': 'Réinitialiser',
    'admin.config.preview': 'Aperçu',
    'admin.config.changes_saved': 'Paramètres sauvegardés',
    'admin.config.changes_saved_desc': 'Tous les paramètres ont été mis à jour avec succès',
    'admin.config.settings_updated': 'Paramètre mis à jour',
    'admin.config.error_loading': 'Impossible de charger les paramètres',
    'admin.config.error_saving': 'Impossible de sauvegarder les paramètres',
    'admin.config.reset_confirm': 'Paramètres réinitialisés',
    'admin.config.reset_confirm_desc': 'Les paramètres par défaut ont été restaurés',
    'admin.config.no_logo': 'Aucun logo',
    'admin.config.no_logo_desc': 'Veuillez d\'abord configurer une URL de logo',
    'admin.config.download_started': 'Téléchargement lancé',
    'admin.config.download_started_desc': 'Le logo est en cours de téléchargement',
    'admin.payment_fees.title': 'Frais de paiement',
    'admin.payment_fees.description': 'Configurez les frais appliqués selon la méthode de paiement',
    'admin.payment_fees.stripe': 'Frais Stripe (%)',
    'admin.payment_fees.mobile': 'Frais Mobile Money (%)',
    'admin.payment_fees.stripe_desc': 'Frais appliqués lors des paiements par carte bancaire via Stripe',
    'admin.payment_fees.mobile_desc': 'Frais appliqués lors des paiements via Orange Money, Airtel Money, M-Pesa',
    'admin.payment_fees.example': 'Exemple',
    'admin.payment_fees.on': 'sur',
    'admin.payment_fees.save': 'Sauvegarder les frais',
    'admin.payment_fees.saving': 'Sauvegarde...',
    'admin.payment_fees.updated': 'Frais mis à jour',
    'admin.payment_fees.updated_desc': 'Les frais de paiement ont été sauvegardés avec succès',
    'admin.payment_fees.error': 'Impossible de sauvegarder les frais',
    'admin.payment_fees.loading': 'Chargement...',

    // API Keys Management
    'admin.api_keys.title': 'API',
    'admin.api_keys.description': 'Gérez les clés API et secrets pour tous les services externes',
    'admin.api_keys.tab': 'Clés API',
    'admin.api_keys.stripe': 'Stripe',
    'admin.api_keys.resend': 'Resend',
    'admin.api_keys.firebase': 'Firebase',
    'admin.api_keys.apns': 'Apple Push Notification',
    'admin.api_keys.environment': 'Environnement',
    'admin.api_keys.test': 'Test',
    'admin.api_keys.live': 'Live',
    'admin.api_keys.active_env': 'Environnement actif',
    'admin.api_keys.switch_env': 'Changer d\'environnement',
    'admin.api_keys.public_key': 'Clé Publique',
    'admin.api_keys.secret_key': 'Clé Secrète',
    'admin.api_keys.webhook_secret': 'Secret Webhook',
    'admin.api_keys.api_key': 'Clé API',
    'admin.api_keys.service_account': 'Service Account JSON',
    'admin.api_keys.private_key': 'Clé Privée',
    'admin.api_keys.key_id': 'Key ID',
    'admin.api_keys.team_id': 'Team ID',
    'admin.api_keys.show': 'Afficher',
    'admin.api_keys.hide': 'Masquer',
    'admin.api_keys.copy': 'Copier',
    'admin.api_keys.copied': 'Copié',
    'admin.api_keys.copied_desc': 'La clé a été copiée dans le presse-papiers',
    'admin.api_keys.save': 'Sauvegarder les modifications',
    'admin.api_keys.saving': 'Enregistrement...',
    'admin.api_keys.saved': 'Clés sauvegardées',
    'admin.api_keys.saved_desc': 'Les clés API ont été sauvegardées avec succès',
    'admin.api_keys.cancel': 'Annuler',
    'admin.api_keys.invalid_format': 'Format invalide',
    'admin.api_keys.invalid_format_desc': 'Le format de la clé est invalide',
    'admin.api_keys.security_warning': 'Avertissement de sécurité',
    'admin.api_keys.security_desc': 'Les clés API sont stockées de manière sécurisée. Ne partagez jamais vos clés de production.',
    'admin.api_keys.admin_only': 'Seuls les administrateurs peuvent voir et modifier ces clés',
    'admin.api_keys.env_changed': 'Environnement changé',
    'admin.api_keys.env_changed_desc': 'L\'environnement actif a été mis à jour',
    'admin.api_keys.placeholder.stripe_public': 'pk_test_... ou pk_live_...',
    'admin.api_keys.placeholder.stripe_secret': 'sk_test_... ou sk_live_...',
    'admin.api_keys.placeholder.stripe_webhook': 'whsec_...',
    'admin.api_keys.placeholder.resend': 're_...',
    'admin.api_keys.placeholder.firebase': '{"type":"service_account",...}',
    'admin.api_keys.placeholder.apns_key': '-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----',
    'admin.api_keys.placeholder.apns_key_id': 'ABC123XYZ',
    'admin.api_keys.placeholder.apns_team_id': 'DEF456UVW',

    // Orders
    'admin.orders.recent': 'Commandes récentes',
    'admin.orders.track': 'Suivre les commandes',
    'admin.orders.order': 'Commande',
    'admin.orders.client': 'Client',
    'admin.orders.vendor': 'Vendeur',
    'admin.orders.amount': 'Montant',
    
    // Orders Page
    'orders.title': 'Mes commandes',
    'orders.subtitle': 'Suivez l\'état de toutes vos commandes',
    'orders.back_home': 'Retour à l\'accueil',
    'orders.tabs.all': 'Toutes',
    'orders.tabs.active': 'Actives',
    'orders.tabs.completed': 'Terminées',
    'orders.tabs.cancelled': 'Annulées',
    'orders.status.PENDING_PAYMENT': 'En attente de paiement',
    'orders.status.PAID': 'Payé',
    'orders.status.PREPARING': 'En préparation',
    'orders.status.READY_FOR_PICKUP': 'Prêt pour retrait',
    'orders.status.AVAILABLE_FOR_PICKUP': 'Disponible pour retrait',
    'orders.status.PICKED_UP': 'Récupéré',
    'orders.status.CANCELLED': 'Annulé',
    'orders.status.EXPIRED': 'Expiré',
    'orders.tracker.created': 'Commande passée',
    'orders.tracker.paid': 'Paiement confirmé',
    'orders.tracker.available': 'Disponible au retrait',
    'orders.tracker.picked_up': 'Récupérée',
    'orders.tracker.in_progress': 'En cours...',

    // Relay Points
    'admin.relays.title': 'Points relais',
    'admin.relays.description': 'Gérer le réseau de points relais',
    'admin.relays.new_relay': 'Nouveau point relais',
    'admin.relays.relay_point': 'Point relais',
    'admin.relays.contact': 'Contact',
    'admin.relays.address': 'Adresse',

    // CMS
    'admin.cms.title': 'CMS et Configuration',
    'admin.api_keys.tab': 'Clés API',

    // Footer
    'footer.description': 'Votre marketplace de confiance à Kinshasa',
    'footer.quick_links': 'Liens rapides',
    'footer.contact': 'Contact',
    'footer.newsletter': 'Newsletter',
    'footer.about': 'À propos',
    'footer.how_it_works': 'Comment ça marche',
    'footer.relay_points': 'Points relais',
    'footer.support': 'Support',
    'footer.email_placeholder': 'Votre email',

    'categories.electronics': 'Électronique',
    'categories.fashion': 'Mode',
    'categories.home': 'Maison',
    'categories.auto': 'Automobile',
    'categories.books': 'Livres',

    // Hero Section
    'hero.title': 'Achetez local, recevez vite',
    'hero.title.location': 'à Kinshasa',
    'hero.tagline': 'Votre marketplace locale',
    'hero.description': 'Découvrez les meilleurs produits locaux et internationaux directement à Kinshasa',
    'hero.explore_products': 'Explorer les produits',
    'hero.become_vendor': 'Devenir vendeur',
    'hero.fast_delivery': 'Livraison rapide',
    'hero.fast_delivery.desc': 'Recevez vos commandes rapidement',
    'hero.secure_payment': 'Paiement sécurisé',
    'hero.secure_payment.desc': 'Vos transactions sont protégées',
    'hero.easy_pickup': 'Retrait facile',
    'hero.easy_pickup.desc': 'Points relais dans toute la ville',
    'hero.secure_order': 'Commande sécurisée',
    'hero.satisfied_customers': '+1000 clients satisfaits',
    
    // Configuration Manager UI
    'admin.config.download': 'Télécharger',
    'admin.config.logo_preview': 'Aperçu du logo',
    'admin.config.logo_preview_desc': 'Le logo sera affiché dans le header et footer',
    'admin.config.image_preview': 'Aperçu',
    'admin.config.enabled': 'Activé',
    'admin.config.disabled': 'Désactivé',
    'admin.config.loading': 'Chargement de la configuration...',
    'admin.config.advanced_title': 'Configuration avancée',
    'admin.config.advanced_desc': 'Personnalisez tous les aspects de votre plateforme',
    'admin.config.unsaved_changes': 'Modifications non sauvegardées',
    'admin.config.saving': 'Sauvegarde...',
    'admin.config.preview_title': 'Aperçu des modifications',
    'admin.config.preview_desc': 'Visualisez vos changements en temps réel sur différents appareils',
    'admin.config.device_desktop': 'Desktop',
    'admin.config.device_tablet': 'Tablette',
    'admin.config.device_mobile': 'Mobile',
    'admin.config.simulation': 'Simulation',
    'admin.config.view_real_site': 'Voir le site réel',
    'admin.config.refresh': 'Actualiser',
    'admin.config.url_placeholder': 'https://example.com/image.jpg ou /image.jpg',
    'admin.config.logo_url_placeholder': 'https://example.com/logo.png ou /logo.png'
  },

  en: {
    // Common
    'common.error': 'Error',
    'common.saved': 'has been saved',
    
    // Header
    'header.hello': 'Hello',
    'header.your_orders': 'Your orders',
    'header.your_account': 'Your account',
    'header.vendor_account': 'Vendor account',
    'header.vendor_dashboard': 'Vendor account',
    'header.admin_panel': 'Administration',
    'header.administration': 'Administration',
    'header.relay_management': 'Relay Management',
    'header.relay_dashboard': 'Relay Management',
    'header.create_business': 'Create my business',
    'header.logout': 'Logout',
    'header.points': 'Relay Points',
    'header.cart': 'Cart',
    'header.search.placeholder': 'Search for a product...',

    // Admin
    'admin.title': 'Administration',
    'admin.subtitle': 'Admin dashboard',
    'admin.system_operational': 'System operational',
    'admin.tabs.dashboard': 'Dashboard',
    'admin.tabs.users': 'Users',
    'admin.tabs.vendors': 'Vendors',
    'admin.tabs.employees': 'Employees',
    'admin.tabs.relays': 'Relay points',
    'admin.tabs.orders': 'Orders',
    'admin.tabs.cms': 'CMS',
    'admin.tabs.config': 'Configuration',

    'admin.analytics.users': 'Users',
    'admin.analytics.vendors': 'Vendors',
    'admin.analytics.orders': 'Orders',
    'admin.analytics.revenue': 'Revenue',
    'admin.analytics.relays': 'Relay points',
    'admin.analytics.employees': 'Employees',

    // Employee/Users Management
    'employee.management': 'User management',
    'employee.total_users': 'Total users',
    'employee.active': 'Active',
    'employee.suspended': 'Suspended',
    'employee.administrators': 'Administrators',
    'employee.user_list': 'User list',
    'employee.user': 'User',
    'employee.role': 'Role',
    'employee.status': 'Status',
    'employee.actions': 'Actions',
    'employee.no_name': 'No name',
    'employee.no_phone': 'No phone',
    'employee.client': 'Client',
    'employee.admin': 'Administrator',
    'employee.super_admin': 'Super Admin',
    'employee.vendor': 'Vendor',
    'employee.relay': 'Relay point',

    // Vendor Management
    'vendor.management': 'Vendor management',
    'vendor.manage_vendors': 'Manage vendors',
    'vendor.tabs.applications': 'Applications',
    'vendor.tabs.vendors': 'Vendors',
    'vendor.tabs.products': 'Products',
    'vendor.tabs.analytics': 'Analytics',
    'vendor.tabs.managers': 'Managers',
    'vendor.applications': 'Vendor applications',
    'vendor.vendor_list': 'Vendor list',
    'vendor.candidate': 'Candidate',
    'vendor.company': 'Company',
    'vendor.type': 'Type',
    'vendor.examine': 'Examine',
    'vendor.product': 'Product',
    'vendor.vendor': 'Vendor',
    'vendor.stock': 'Stock',
    'vendor.creation_date': 'Creation date',

    // Configuration
    'admin.config.categories.general': 'General',
    'admin.config.categories.general_desc': 'General site settings',
    'admin.config.site_info': 'Site information',
    'admin.config.site_name': 'Site name',
    'admin.config.platform_name': 'The main name of your platform',
    'admin.config.tagline': 'Tagline',
    'admin.config.tagline_desc': 'Short description of your platform',
    'admin.config.description': 'Description',
    'admin.config.description_desc': 'Detailed description for SEO',
    'admin.config.logo_images': 'Logo and images',
    'admin.config.logo_url': 'Site logo',
    'admin.config.logo_url_desc': 'Logo URL (leave empty to use default icon)',
    'admin.config.hero_image': 'Hero section image',
    'admin.config.hero_image_desc': 'URL of homepage main image',
    'admin.config.contact_support': 'Contact and support',
    'admin.config.contact_email': 'Contact email',
    'admin.config.contact_email_desc': 'Main email address',
    'admin.config.support_phone': 'Support phone',
    'admin.config.support_phone_desc': 'Customer support phone number',
    'admin.config.maintenance_mode': 'Maintenance mode',
    'admin.config.maintenance_mode_desc': 'Enable site maintenance mode',
    'admin.config.show_announcement_banner': 'Show announcement banner',
    'admin.config.show_announcement_banner_desc': 'Show or hide the orange banner at the top of the site (active even in maintenance mode)',
    'admin.config.password_reset_expiry': 'Password reset link expiry',
    'admin.config.password_reset_expiry_desc': 'Validity duration for password reset links (in minutes, between 5 and 1440)',
    'admin.config.footer': 'Footer',
    'admin.config.footer_address': 'Address',
    'admin.config.footer_address_desc': 'Address to display in footer',
    'admin.config.footer_copyright': 'Copyright text',
    'admin.config.footer_copyright_desc': 'Copyright text at bottom of page',
    'admin.config.footer_facebook': 'Facebook link',
    'admin.config.footer_facebook_desc': 'Your Facebook page URL',
    'admin.config.footer_twitter': 'Twitter/X link',
    'admin.config.footer_twitter_desc': 'Your Twitter account URL',
    'admin.config.footer_instagram': 'Instagram link',
    'admin.config.footer_instagram_desc': 'Your Instagram account URL',
    'admin.config.appearance': 'Appearance',
    'admin.config.appearance_desc': 'Customize appearance',
    'admin.config.theme_colors': 'Theme and colors',
    'admin.config.primary_color': 'Primary color',
    'admin.config.primary_color_desc': 'Your brand\'s main color',
    'admin.config.secondary_color': 'Secondary color',
    'admin.config.secondary_color_desc': 'Secondary color for accents',
    'admin.config.dark_mode': 'Dark mode',
    'admin.config.dark_mode_desc': 'Allow dark mode toggle',
    'admin.config.ui': 'User interface',
    'admin.config.border_radius': 'Border radius',
    'admin.config.border_radius_desc': 'Adjust element rounding (px)',
    'admin.config.animation_speed': 'Animation speed',
    'admin.config.animation_speed_desc': 'Transition speed (ms)',
    'admin.config.payment': 'Payments',
    'admin.config.payment_desc': 'Payment configuration',
    'admin.config.payment_methods': 'Payment methods',
    'admin.config.stripe_enabled': 'Stripe enabled',
    'admin.config.stripe_enabled_desc': 'Enable Stripe card payments',
    'admin.config.mobile_money': 'Mobile Money',
    'admin.config.mobile_money_desc': 'Enable mobile money payments',
    'admin.config.cash_on_delivery': 'Cash on delivery',
    'admin.config.cash_on_delivery_desc': 'Allow payment on receipt',
    'admin.config.fees': 'Fee configuration',
    'admin.config.transaction_fee': 'Transaction fee (%)',
    'admin.config.transaction_fee_desc': 'Percentage taken on each sale',
    'admin.config.min_order': 'Minimum order amount',
    'admin.config.min_order_desc': 'Minimum amount to place order (CDF)',
    'admin.config.payment_simulation': 'Payment simulation (test)',
    'admin.config.payment_country_simulation_enabled': 'Enable country simulation',
    'admin.config.payment_country_simulation_enabled_desc': 'Force a test country for payment routing (admin only)',
    'admin.config.payment_country_simulation_country': 'Simulated country',
    'admin.config.payment_country_simulation_country_desc': 'Select country to simulate (e.g. CD to test Flutterwave)',
    'admin.config.shipping': 'Shipping',
    'admin.config.shipping_desc': 'Shipping settings',
    'admin.config.shipping_options': 'Shipping options',
    'admin.config.default_shipping_cost': 'Default shipping cost',
    'admin.config.default_shipping_cost_desc': 'Standard shipping price (CDF)',
    'admin.config.free_shipping_threshold': 'Free shipping threshold',
    'admin.config.free_shipping_threshold_desc': 'Amount for free shipping (CDF)',
    'admin.config.delivery_days': 'Estimated delivery time',
    'admin.config.delivery_days_desc': 'Number of days for standard delivery',
    'admin.config.notifications': 'Notifications',
    'admin.config.notifications_desc': 'Manage notifications',
    'admin.config.email_notifications': 'Email notifications',
    'admin.config.email_enabled': 'Email notifications',
    'admin.config.email_enabled_desc': 'Send email notifications',
    'admin.config.order_confirmation': 'Order confirmation',
    'admin.config.order_confirmation_desc': 'Confirmation email after order',
    'admin.config.shipping_notification': 'Shipping notification',
    'admin.config.shipping_notification_desc': 'Email when shipped',
    'admin.config.sms_notifications': 'SMS notifications',
    'admin.config.sms_enabled': 'SMS notifications',
    'admin.config.sms_enabled_desc': 'Send SMS notifications',
    'admin.config.security': 'Security',
    'admin.config.security_desc': 'Security settings',
    'admin.config.authentication': 'Authentication',
    'admin.config.email_verification': 'Require email verification',
    'admin.config.email_verification_desc': 'Require email verification at signup',
    'admin.config.password_length': 'Minimum password length',
    'admin.config.password_length_desc': 'Minimum number of characters',
    'admin.config.session_timeout': 'Session timeout (minutes)',
    'admin.config.session_timeout_desc': 'Duration before automatic logout',
    'admin.config.save_all': 'Save all settings',
    'admin.config.reset': 'Reset',
    'admin.config.preview': 'Preview',
    'admin.config.changes_saved': 'Settings saved',
    'admin.config.changes_saved_desc': 'All settings have been successfully updated',
    'admin.config.settings_updated': 'Setting updated',
    'admin.config.error_loading': 'Unable to load settings',
    'admin.config.error_saving': 'Unable to save settings',
    'admin.config.reset_confirm': 'Settings reset',
    'admin.config.reset_confirm_desc': 'Default settings have been restored',
    'admin.config.no_logo': 'No logo',
    'admin.config.no_logo_desc': 'Please configure a logo URL first',
    'admin.config.download_started': 'Download started',
    'admin.config.download_started_desc': 'Logo is downloading',
    'admin.payment_fees.title': 'Payment fees',
    'admin.payment_fees.description': 'Configure fees applied by payment method',
    'admin.payment_fees.stripe': 'Stripe fees (%)',
    'admin.payment_fees.mobile': 'Mobile Money fees (%)',
    'admin.payment_fees.stripe_desc': 'Fees applied for Stripe card payments',
    'admin.payment_fees.mobile_desc': 'Fees applied for Orange Money, Airtel Money, M-Pesa payments',
    'admin.payment_fees.example': 'Example',
    'admin.payment_fees.on': 'on',
    'admin.payment_fees.save': 'Save fees',
    'admin.payment_fees.saving': 'Saving...',
    'admin.payment_fees.updated': 'Fees updated',
    'admin.payment_fees.updated_desc': 'Payment fees have been successfully saved',
    'admin.payment_fees.error': 'Unable to save fees',
    'admin.payment_fees.loading': 'Loading...',

    // API Keys Management
    'admin.api_keys.title': 'API Keys Management',
    'admin.api_keys.description': 'Manage API keys and secrets for all external services',
    'admin.api_keys.tab': 'API',
    'admin.api_keys.stripe': 'Stripe',
    'admin.api_keys.resend': 'Resend',
    'admin.api_keys.firebase': 'Firebase',
    'admin.api_keys.apns': 'Apple Push Notification',
    'admin.api_keys.environment': 'Environment',
    'admin.api_keys.test': 'Test',
    'admin.api_keys.live': 'Live',
    'admin.api_keys.active_env': 'Active environment',
    'admin.api_keys.switch_env': 'Switch environment',
    'admin.api_keys.public_key': 'Public Key',
    'admin.api_keys.secret_key': 'Secret Key',
    'admin.api_keys.webhook_secret': 'Webhook Secret',
    'admin.api_keys.api_key': 'API Key',
    'admin.api_keys.service_account': 'Service Account JSON',
    'admin.api_keys.private_key': 'Private Key',
    'admin.api_keys.key_id': 'Key ID',
    'admin.api_keys.team_id': 'Team ID',
    'admin.api_keys.show': 'Show',
    'admin.api_keys.hide': 'Hide',
    'admin.api_keys.copy': 'Copy',
    'admin.api_keys.copied': 'Copied',
    'admin.api_keys.copied_desc': 'Key copied to clipboard',
    'admin.api_keys.save': 'Save changes',
    'admin.api_keys.saving': 'Saving...',
    'admin.api_keys.saved': 'Keys saved',
    'admin.api_keys.saved_desc': 'API keys saved successfully',
    'admin.api_keys.cancel': 'Cancel',
    'admin.api_keys.invalid_format': 'Invalid format',
    'admin.api_keys.invalid_format_desc': 'Key format is invalid',
    'admin.api_keys.security_warning': 'Security Warning',
    'admin.api_keys.security_desc': 'API keys are stored securely. Never share your production keys.',
    'admin.api_keys.admin_only': 'Only administrators can view and modify these keys',
    'admin.api_keys.env_changed': 'Environment changed',
    'admin.api_keys.env_changed_desc': 'Active environment has been updated',
    'admin.api_keys.placeholder.stripe_public': 'pk_test_... or pk_live_...',
    'admin.api_keys.placeholder.stripe_secret': 'sk_test_... or sk_live_...',
    'admin.api_keys.placeholder.stripe_webhook': 'whsec_...',
    'admin.api_keys.placeholder.resend': 're_...',
    'admin.api_keys.placeholder.firebase': '{"type":"service_account",...}',
    'admin.api_keys.placeholder.apns_key': '-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----',
    'admin.api_keys.placeholder.apns_key_id': 'ABC123XYZ',
    'admin.api_keys.placeholder.apns_team_id': 'DEF456UVW',

    // Orders
    'admin.orders.recent': 'Recent orders',
    'admin.orders.track': 'Track orders',
    'admin.orders.order': 'Order',
    'admin.orders.client': 'Client',
    'admin.orders.vendor': 'Vendor',
    'admin.orders.amount': 'Amount',
    
    // Orders Page
    'orders.title': 'My Orders',
    'orders.subtitle': 'Track the status of all your orders',
    'orders.back_home': 'Back to home',
    'orders.tabs.all': 'All',
    'orders.tabs.active': 'Active',
    'orders.tabs.completed': 'Completed',
    'orders.tabs.cancelled': 'Cancelled',
    'orders.status.PENDING_PAYMENT': 'Pending payment',
    'orders.status.PAID': 'Paid',
    'orders.status.PREPARING': 'Preparing',
    'orders.status.READY_FOR_PICKUP': 'Ready for pickup',
    'orders.status.AVAILABLE_FOR_PICKUP': 'Available for pickup',
    'orders.status.PICKED_UP': 'Picked up',
    'orders.status.CANCELLED': 'Cancelled',
    'orders.status.EXPIRED': 'Expired',
    'orders.tracker.created': 'Order placed',
    'orders.tracker.paid': 'Payment confirmed',
    'orders.tracker.available': 'Available for pickup',
    'orders.tracker.picked_up': 'Picked up',
    'orders.tracker.in_progress': 'In progress...',

    // Relay Points
    'admin.relays.title': 'Relay points',
    'admin.relays.description': 'Manage relay network',
    'admin.relays.new_relay': 'New relay point',
    'admin.relays.relay_point': 'Relay point',
    'admin.relays.contact': 'Contact',
    'admin.relays.address': 'Address',

    // CMS
    'admin.cms.title': 'CMS & Configuration',
    'admin.cms.description': 'Manage site content',

    // Footer
    'footer.description': 'Your trusted marketplace in Kinshasa',
    'footer.quick_links': 'Quick links',
    'footer.categories': 'Categories',
    'footer.contact': 'Contact',
    'footer.newsletter': 'Newsletter',
    'footer.about': 'About',
    'footer.how_it_works': 'How it works',
    'footer.become_vendor': 'Become vendor',
    'footer.relay_points': 'Relay points',
    'footer.support': 'Support',
    'footer.email_placeholder': 'Your email',

    // Categories
    'categories.electronics': 'Electronics',
    'categories.fashion': 'Fashion',
    'categories.home': 'Home',
    'categories.auto': 'Automotive',
    'categories.books': 'Books',

    // Hero Section
    'hero.title': 'Shop local, receive fast',
    'hero.title.location': 'in Kinshasa',
    'hero.tagline': 'Your local marketplace',
    'hero.description': 'Discover the best local and international products directly in Kinshasa',
    'hero.explore_products': 'Explore products',
    'hero.become_vendor': 'Become vendor',
    'hero.fast_delivery': 'Fast delivery',
    'hero.fast_delivery.desc': 'Receive your orders quickly',
    'hero.secure_payment': 'Secure payment',
    'hero.secure_payment.desc': 'Your transactions are protected',
    'hero.easy_pickup': 'Easy pickup',
    'hero.easy_pickup.desc': 'Relay points throughout the city',
    'hero.secure_order': 'Secure order',
    'hero.satisfied_customers': '+1000 satisfied customers',
    
    // Configuration Manager UI
    'admin.config.download': 'Download',
    'admin.config.logo_preview': 'Logo preview',
    'admin.config.logo_preview_desc': 'The logo will be displayed in header and footer',
    'admin.config.image_preview': 'Preview',
    'admin.config.enabled': 'Enabled',
    'admin.config.disabled': 'Disabled',
    'admin.config.loading': 'Loading configuration...',
    'admin.config.advanced_title': 'Advanced configuration',
    'admin.config.advanced_desc': 'Customize all aspects of your platform',
    'admin.config.unsaved_changes': 'Unsaved changes',
    'admin.config.saving': 'Saving...',
    'admin.config.preview_title': 'Preview changes',
    'admin.config.preview_desc': 'Visualize your changes in real-time on different devices',
    'admin.config.device_desktop': 'Desktop',
    'admin.config.device_tablet': 'Tablet',
    'admin.config.device_mobile': 'Mobile',
    'admin.config.simulation': 'Simulation',
    'admin.config.view_real_site': 'View real site',
    'admin.config.refresh': 'Refresh',
    'admin.config.url_placeholder': 'https://example.com/image.jpg or /image.jpg',
    'admin.config.logo_url_placeholder': 'https://example.com/logo.png or /logo.png'
  },

  'lg-fr': {
    // Common
    'common.error': 'Libunga',
    'common.saved': 'ebombami',
    
    // Header
    'header.hello': 'Mbote',
    'header.your_orders': 'Ba commande na yo',
    'header.your_account': 'Compte na yo',
    'header.vendor_account': 'Compte ya moteki',
    'header.admin_panel': 'Boyangeli',
    'header.points': 'Bisika ya kozongela',
    'header.cart': 'Saki',
    'header.search.placeholder': 'Luka eloko...',

    // Admin
    'admin.title': 'Boyangeli',
    'admin.subtitle': 'Mokanda ya boyangeli',
    'admin.system_operational': 'Système ezali kosala',
    'admin.tabs.dashboard': 'Mokanda',
    'admin.tabs.users': 'Basaleli',
    'admin.tabs.vendors': 'Bateki',
    'admin.tabs.employees': 'Basali',
    'admin.tabs.relays': 'Bisika ya kozongela',
    'admin.tabs.orders': 'Ba commande',
    'admin.tabs.cms': 'CMS',
    'admin.tabs.config': 'Configuration',

    'admin.analytics.users': 'Basaleli',
    'admin.analytics.vendors': 'Bateki',
    'admin.analytics.orders': 'Ba commande',
    'admin.analytics.revenue': 'Mbongo ya litomba',
    'admin.analytics.relays': 'Bisika ya kozongela',
    'admin.analytics.employees': 'Basali',

    // Employee/Users Management
    'employee.management': 'Boyangeli ya basaleli',
    'employee.total_users': 'Basaleli nyonso',
    'employee.active': 'Oyo bazali kosala',
    'employee.suspended': 'Oyo batelemaki',
    'employee.administrators': 'Bayangeli',
    'employee.user_list': 'Liste ya basaleli',
    'employee.user': 'Mosaleli',
    'employee.role': 'Mosala',
    'employee.status': 'Ndenge ezali',
    'employee.actions': 'Misala',
    'employee.no_name': 'Kombo te',
    'employee.no_phone': 'Telefone te',
    'employee.client': 'Client',
    'employee.admin': 'Moyangeli',
    'employee.super_admin': 'Moyangeli monene',
    'employee.vendor': 'Moteki',
    'employee.relay': 'Esika ya kozongela',

    // Vendor Management
    'vendor.management': 'Boyangeli ya bateki',
    'vendor.manage_vendors': 'Yangela bateki',
    'vendor.tabs.applications': 'Ba demande',
    'vendor.tabs.vendors': 'Bateki',
    'vendor.tabs.products': 'Biloko',
    'vendor.tabs.analytics': 'Analytics',
    'vendor.tabs.managers': 'Bayangeli',
    'vendor.applications': 'Ba demande ya bateki',
    'vendor.vendor_list': 'Liste ya bateki',
    'vendor.candidate': 'Oyo asengi',
    'vendor.company': 'Société',
    'vendor.type': 'Lolenge',
    'vendor.examine': 'Tala',
    'vendor.product': 'Eloko',
    'vendor.vendor': 'Moteki',
    'vendor.stock': 'Stock',
    'vendor.creation_date': 'Mokolo ya kosala',
    
    // Configuration
    'admin.config.categories.general': 'Général',
    'admin.config.categories.general_desc': 'Ba paramètres ya général',
    'admin.config.site_info': 'Ba sango ya site',
    'admin.config.site_name': 'Nkombo ya site',
    'admin.config.platform_name': 'Nkombo ya monene ya plateforme',
    'admin.config.tagline': 'Slogan',
    'admin.config.tagline_desc': 'Ndimbola mokuse ya plateforme',
    'admin.config.description': 'Ndimbola',
    'admin.config.description_desc': 'Ndimbola ya makasi pona SEO',
    'admin.config.logo_images': 'Logo na bililingi',
    'admin.config.logo_url': 'Logo ya site',
    'admin.config.logo_url_desc': 'URL ya logo',
    'admin.config.hero_image': 'Elilingi ya hero',
    'admin.config.hero_image_desc': 'URL ya elilingi ya ebandeli',
    'admin.config.contact_support': 'Contact na lisalisi',
    'admin.config.contact_email': 'Email ya contact',
    'admin.config.contact_email_desc': 'Email ya ebandeli',
    'admin.config.support_phone': 'Telefone ya lisalisi',
    'admin.config.support_phone_desc': 'Motango ya telefone ya lisalisi',
    'admin.config.maintenance_mode': 'Mode maintenance',
    'admin.config.maintenance_mode_desc': 'Kotya mode maintenance',
    'admin.config.show_announcement_banner': 'Lakisa bandeau ya annonce',
    'admin.config.show_announcement_banner_desc': 'Lakisa to planque bandeau ya orange na likolo ya site (aktif nanu na mode maintenance)',
    'admin.config.password_reset_expiry': 'Expiration ya lien ya kobongola mot de passe',
    'admin.config.password_reset_expiry_desc': 'Ntango ya validité ya ba liens ya kobongola mot de passe (na ba minutes, entre 5 na 1440)',
    'admin.config.footer': 'Footer',
    'admin.config.footer_address': 'Adresse',
    'admin.config.footer_address_desc': 'Adresse ya komonisa na footer',
    'admin.config.footer_copyright': 'Makomi ya copyright',
    'admin.config.footer_copyright_desc': 'Makomi ya copyright na nse',
    'admin.config.footer_facebook': 'Lien Facebook',
    'admin.config.footer_facebook_desc': 'URL ya page Facebook',
    'admin.config.footer_twitter': 'Lien Twitter/X',
    'admin.config.footer_twitter_desc': 'URL ya compte Twitter',
    'admin.config.footer_instagram': 'Lien Instagram',
    'admin.config.footer_instagram_desc': 'URL ya compte Instagram',
    'admin.config.appearance': 'Lolenge',
    'admin.config.appearance_desc': 'Kobongisa lolenge',
    'admin.config.theme_colors': 'Thème na balangi',
    'admin.config.primary_color': 'Langi ya ebandeli',
    'admin.config.primary_color_desc': 'Langi ya monene ya marque',
    'admin.config.secondary_color': 'Langi ya mibale',
    'admin.config.secondary_color_desc': 'Langi ya mibale pona ba accents',
    'admin.config.dark_mode': 'Mode molili',
    'admin.config.dark_mode_desc': 'Kopesa nzela ya mode molili',
    'admin.config.ui': 'Interface',
    'admin.config.border_radius': 'Rayon ya bordure',
    'admin.config.border_radius_desc': 'Kobongisa arrondi (px)',
    'admin.config.animation_speed': 'Vitesse ya animation',
    'admin.config.animation_speed_desc': 'Vitesse ya transitions (ms)',
    'admin.config.payment': 'Ba paiement',
    'admin.config.payment_desc': 'Configuration ya ba paiement',
    'admin.config.payment_methods': 'Ba méthode ya kofuta',
    'admin.config.stripe_enabled': 'Stripe ezali',
    'admin.config.stripe_enabled_desc': 'Kotya Stripe',
    'admin.config.mobile_money': 'Mobile Money',
    'admin.config.mobile_money_desc': 'Kotya Mobile Money',
    'admin.config.cash_on_delivery': 'Kofuta ntango okozwa',
    'admin.config.cash_on_delivery_desc': 'Kopesa nzela ya kofuta ntango okozwa',
    'admin.config.fees': 'Configuration ya ba frais',
    'admin.config.transaction_fee': 'Frais ya transaction (%)',
    'admin.config.transaction_fee_desc': 'Pourcentage oyo bazwi na vente',
    'admin.config.min_order': 'Mbongo ya moke ya commande',
    'admin.config.min_order_desc': 'Mbongo ya moke pona kosala commande (CDF)',
    'admin.config.payment_simulation': 'Simulation ya paiement (test)',
    'admin.config.payment_country_simulation_enabled': 'Kotya simulation ya mboka',
    'admin.config.payment_country_simulation_enabled_desc': 'Ko forcer mboka ya test pona routing ya paiement (admin kaka)',
    'admin.config.payment_country_simulation_country': 'Mboka ya simulation',
    'admin.config.payment_country_simulation_country_desc': 'Pona mboka ya simulation (ndakisa: CD pona komeka Flutterwave)',
    'admin.config.shipping': 'Livraison',
    'admin.config.shipping_desc': 'Ba paramètres ya livraison',
    'admin.config.shipping_options': 'Ba options ya livraison',
    'admin.config.default_shipping_cost': 'Prix ya livraison',
    'admin.config.default_shipping_cost_desc': 'Prix standard ya livraison (CDF)',
    'admin.config.free_shipping_threshold': 'Seuil pona livraison ya ofele',
    'admin.config.free_shipping_threshold_desc': 'Mbongo pona livraison ya ofele (CDF)',
    'admin.config.delivery_days': 'Mikolo ya livraison',
    'admin.config.delivery_days_desc': 'Motango ya mikolo pona livraison',
    'admin.config.notifications': 'Ba notification',
    'admin.config.notifications_desc': 'Boyangeli ya ba notification',
    'admin.config.email_notifications': 'Ba notification email',
    'admin.config.email_enabled': 'Ba notification email',
    'admin.config.email_enabled_desc': 'Kotinda ba notification na email',
    'admin.config.order_confirmation': 'Confirmation ya commande',
    'admin.config.order_confirmation_desc': 'Email ya confirmation sima ya commande',
    'admin.config.shipping_notification': 'Notification ya expédition',
    'admin.config.shipping_notification_desc': 'Email ntango ba expédier',
    'admin.config.sms_notifications': 'Ba notification SMS',
    'admin.config.sms_enabled': 'Ba notification SMS',
    'admin.config.sms_enabled_desc': 'Kotinda ba notification na SMS',
    'admin.config.security': 'Sécurité',
    'admin.config.security_desc': 'Ba paramètres ya sécurité',
    'admin.config.authentication': 'Authentification',
    'admin.config.email_verification': 'Vérification email obligatoire',
    'admin.config.email_verification_desc': 'Ko obliger vérification ya email',
    'admin.config.password_length': 'Bolai ya moke ya mot de passe',
    'admin.config.password_length_desc': 'Motango ya moke ya ba caractères',
    'admin.config.session_timeout': 'Timeout ya session (minutes)',
    'admin.config.session_timeout_desc': 'Ntango liboso ya déconnexion automatique',
    'admin.config.save_all': 'Kobomba ba paramètres nyonso',
    'admin.config.reset': 'Kozongisa',
    'admin.config.preview': 'Aperçu',
    'admin.config.changes_saved': 'Ba paramètres ebombami',
    'admin.config.changes_saved_desc': 'Ba paramètres nyonso ebongwani malamu',
    'admin.config.settings_updated': 'Paramètre ebongwani',
    'admin.config.error_loading': 'Ekoki te kozwa ba paramètres',
    'admin.config.error_saving': 'Ekoki te kobomba ba paramètres',
    'admin.config.reset_confirm': 'Ba paramètres ezongisami',
    'admin.config.reset_confirm_desc': 'Ba paramètres ya ebandeli ezongisami',
    'admin.config.no_logo': 'Logo ezali te',
    'admin.config.no_logo_desc': 'Oza na URL ya logo liboso',
    'admin.config.download_started': 'Téléchargement ebandi',
    'admin.config.download_started_desc': 'Logo ezali ko télécharger',
    'admin.payment_fees.title': 'Ba frais ya kofuta',
    'admin.payment_fees.description': 'Kobongisa ba frais',
    'admin.payment_fees.stripe': 'Ba frais Stripe (%)',
    'admin.payment_fees.mobile': 'Ba frais Mobile Money (%)',
    'admin.payment_fees.stripe_desc': 'Ba frais pona ba paiement Stripe',
    'admin.payment_fees.mobile_desc': 'Ba frais pona Orange Money, Airtel Money, M-Pesa',
    'admin.payment_fees.example': 'Ndakisa',
    'admin.payment_fees.on': 'na',
    'admin.payment_fees.save': 'Kobomba ba frais',
    'admin.payment_fees.saving': 'Ezali kobomba...',
    'admin.payment_fees.updated': 'Ba frais ebongwani',
    'admin.payment_fees.updated_desc': 'Ba frais ya kofuta ebombami malamu',
    'admin.payment_fees.error': 'Ekoki te kobomba ba frais',
    'admin.payment_fees.loading': 'Ezali kokanga...',

    // API Keys Management
    'admin.api_keys.title': 'Boyangeli ya ba clé API',
    'admin.api_keys.description': 'Boyangeli ya ba clé API na ba secret mpo na ba service nyonso ya libanda',
    'admin.api_keys.tab': 'API',
    'admin.api_keys.stripe': 'Stripe',
    'admin.api_keys.resend': 'Resend',
    'admin.api_keys.firebase': 'Firebase',
    'admin.api_keys.apns': 'Apple Push Notification',
    'admin.api_keys.environment': 'Environnement',
    'admin.api_keys.test': 'Test',
    'admin.api_keys.live': 'Live',
    'admin.api_keys.active_env': 'Environnement ya kosalela',
    'admin.api_keys.switch_env': 'Kobongola environnement',
    'admin.api_keys.public_key': 'Clé ya liboso',
    'admin.api_keys.secret_key': 'Clé ya secret',
    'admin.api_keys.webhook_secret': 'Secret webhook',
    'admin.api_keys.api_key': 'Clé API',
    'admin.api_keys.service_account': 'Service Account JSON',
    'admin.api_keys.private_key': 'Clé privée',
    'admin.api_keys.key_id': 'Key ID',
    'admin.api_keys.team_id': 'Team ID',
    'admin.api_keys.show': 'Kolakisa',
    'admin.api_keys.hide': 'Kobomba',
    'admin.api_keys.copy': 'Kokopya',
    'admin.api_keys.copied': 'Ekopyami',
    'admin.api_keys.copied_desc': 'Clé ekopyami na clipboard',
    'admin.api_keys.save': 'Kobomba ba changement',
    'admin.api_keys.saving': 'Kozala kobomba...',
    'admin.api_keys.saved': 'Ba clé ebombami',
    'admin.api_keys.saved_desc': 'Ba clé API ebombami malamu',
    'admin.api_keys.cancel': 'Kozongisa',
    'admin.api_keys.invalid_format': 'Format ezali malamu te',
    'admin.api_keys.invalid_format_desc': 'Format ya clé ezali malamu te',
    'admin.api_keys.security_warning': 'Ebimiseli ya sécurité',
    'admin.api_keys.security_desc': 'Ba clé API ebombami na sécurité. Okabola clé ya production te.',
    'admin.api_keys.admin_only': 'Ba administrateur kaka bakoki komona na kobongola ba clé oyo',
    'admin.api_keys.env_changed': 'Environnement ebongwani',
    'admin.api_keys.env_changed_desc': 'Environnement ya kosalela esalemi mise à jour',
    'admin.api_keys.placeholder.stripe_public': 'pk_test_... to pk_live_...',
    'admin.api_keys.placeholder.stripe_secret': 'sk_test_... to sk_live_...',
    'admin.api_keys.placeholder.stripe_webhook': 'whsec_...',
    'admin.api_keys.placeholder.resend': 're_...',
    'admin.api_keys.placeholder.firebase': '{"type":"service_account",...}',
    'admin.api_keys.placeholder.apns_key': '-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----',
    'admin.api_keys.placeholder.apns_key_id': 'ABC123XYZ',
    'admin.api_keys.placeholder.apns_team_id': 'DEF456UVW',

    // Orders
    'admin.orders.recent': 'Ba commande ya sika',
    'admin.orders.track': 'Kolandela ba commande',
    'admin.orders.order': 'Commande',
    'admin.orders.client': 'Client',
    'admin.orders.vendor': 'Moteki',
    'admin.orders.amount': 'Mbongo',
    
    // Orders Page
    'orders.title': 'Ba commande na ngai',
    'orders.subtitle': 'Landela ndenge ba commande na yo ezali',
    'orders.back_home': 'Zonga na ebandeli',
    'orders.tabs.all': 'Nyonso',
    'orders.tabs.active': 'Oyo ezali kosala',
    'orders.tabs.completed': 'Oyo esilaki',
    'orders.tabs.cancelled': 'Oyo ebatalaki',
    'orders.status.PENDING_PAYMENT': 'Ezali kozela kofuta',
    'orders.status.PAID': 'Efutami',
    'orders.status.PREPARING': 'Ezali kobongisama',
    'orders.status.READY_FOR_PICKUP': 'Ezali pene ya kozua',
    'orders.status.AVAILABLE_FOR_PICKUP': 'Ezali pene ya kozua',
    'orders.status.PICKED_UP': 'Ezuami',
    'orders.status.CANCELLED': 'Ebatalaki',
    'orders.status.EXPIRED': 'Etikali',
    'orders.tracker.created': 'Order esalami',
    'orders.tracker.paid': 'Mbongo ekokisami',
    'orders.tracker.available': 'Ezali pona kozwa',
    'orders.tracker.picked_up': 'Ezwami',
    'orders.tracker.in_progress': 'Ezali kosalema...',

    // Footer
    'footer.description': 'Esika na bino ya kotek biloko na Kinshasa',
    'footer.quick_links': 'Ba lien ya mbangu',
    'footer.categories': 'Mitindo',
    'footer.contact': 'Kosolola',
    'footer.newsletter': 'Nsango',
    'footer.about': 'Na ntina na biso',
    'footer.how_it_works': 'Ndenge esalaka',
    'footer.become_vendor': 'Koma moteki',
    'footer.relay_points': 'Bisika ya kozongela',
    'footer.support': 'Lisalisi',
    'footer.email_placeholder': 'Email na yo',

    // Categories
    'categories.electronics': 'Baapparei électroniques',
    'categories.fashion': 'Bilamba',
    'categories.home': 'Ndako',
    'categories.auto': 'Motuka',
    'categories.books': 'Mikanda',

    // Hero Section
    'hero.title': 'Somba awa, zonga noki',
    'hero.title.location': 'na Kinshasa',
    'hero.tagline': 'Esika na bino ya koteka',
    'hero.description': 'Talá biloko ya malamu ya awa na ya mikili mosusu na Kinshasa',
    'hero.explore_products': 'Tala biloko',
    'hero.become_vendor': 'Koma moteki',
    'hero.fast_delivery': 'Livraison ya mbangu',
    'hero.fast_delivery.desc': 'Zwa biloko na yo noki',
    'hero.secure_payment': 'Kofuta na libateli',
    'hero.secure_payment.desc': 'Ba transaction na yo ezali na protection',
    'hero.easy_pickup': 'Kozwa mpasi te',
    'hero.easy_pickup.desc': 'Ba points relais na engumba mobimba',
    'hero.secure_order': 'Commande ya libateli',
    'hero.satisfied_customers': '+1000 ba clients ya esengo',
    
    // Configuration Manager UI
    'admin.config.download': 'Kokitisa',
    'admin.config.logo_preview': 'Komona logo',
    'admin.config.logo_preview_desc': 'Logo ekomonisama na header na footer',
    'admin.config.image_preview': 'Komona',
    'admin.config.enabled': 'Efungwami',
    'admin.config.disabled': 'Ekangami',
    'admin.config.loading': 'Kozala kotia configuration...',
    'admin.config.advanced_title': 'Configuration avancée',
    'admin.config.advanced_desc': 'Kobongisa makambu nionso ya plateforme',
    'admin.config.unsaved_changes': 'Mbongwana oyo ebombami te',
    'admin.config.saving': 'Kobomba...',
    'admin.config.preview_title': 'Komona mbongwana',
    'admin.config.preview_desc': 'Talá mbongwana na yo na ntango ya solo na baapareil ndenge na ndenge',
    'admin.config.device_desktop': 'Desktop',
    'admin.config.device_tablet': 'Tablette',
    'admin.config.device_mobile': 'Mobile',
    'admin.config.simulation': 'Simulation',
    'admin.config.view_real_site': 'Komona site ya solo',
    'admin.config.refresh': 'Ko-actualiser',
    'admin.config.url_placeholder': 'https://example.com/image.jpg to /image.jpg',
    'admin.config.logo_url_placeholder': 'https://example.com/logo.png to /logo.png'
  },

  sw: {
    // Common
    'common.error': 'Kosa',
    'common.saved': 'imehifadhiwa',
    
    // Header
    'header.hello': 'Hujambo',
    'header.your_orders': 'Maagizo yako',
    'header.your_account': 'Akaunti yako',
    'header.vendor_account': 'Akaunti ya muuzaji',
    'header.admin_panel': 'Utawala',
    'header.points': 'Vituo vya kuchukua',
    'header.cart': 'Kikapu',
    'header.search.placeholder': 'Tafuta bidhaa...',

    // Admin
    'admin.title': 'Utawala',
    'admin.subtitle': 'Dashibodi ya utawala',
    'admin.system_operational': 'Mfumo unafanya kazi',
    'admin.tabs.dashboard': 'Dashibodi',
    'admin.tabs.users': 'Watumiaji',
    'admin.tabs.vendors': 'Wauzaji',
    'admin.tabs.employees': 'Wafanyakazi',
    'admin.tabs.relays': 'Vituo vya kuchukua',
    'admin.tabs.orders': 'Maagizo',
    'admin.tabs.cms': 'CMS',
    'admin.tabs.config': 'Usanidi',

    'admin.analytics.users': 'Watumiaji',
    'admin.analytics.vendors': 'Wauzaji',
    'admin.analytics.orders': 'Maagizo',
    'admin.analytics.revenue': 'Mapato',
    'admin.analytics.relays': 'Vituo vya kuchukua',
    'admin.analytics.employees': 'Wafanyakazi',

    // Employee/Users Management
    'employee.management': 'Usimamizi wa watumiaji',
    'employee.total_users': 'Watumiaji wote',
    'employee.active': 'Hai',
    'employee.suspended': 'Wamesimamishwa',
    'employee.administrators': 'Wasimamizi',
    'employee.user_list': 'Orodha ya watumiaji',
    'employee.user': 'Mtumiaji',
    'employee.role': 'Jukumu',
    'employee.status': 'Hali',
    'employee.actions': 'Vitendo',
    'employee.no_name': 'Hakuna jina',
    'employee.no_phone': 'Hakuna simu',
    'employee.client': 'Mteja',
    'employee.admin': 'Msimamizi',
    'employee.super_admin': 'Msimamizi Mkuu',
    'employee.vendor': 'Muuzaji',
    'employee.relay': 'Kituo cha kuchukua',

    // Vendor Management
    'vendor.management': 'Usimamizi wa wauzaji',
    'vendor.manage_vendors': 'Simamia wauzaji',
    'vendor.tabs.applications': 'Maombi',
    'vendor.tabs.vendors': 'Wauzaji',
    'vendor.tabs.products': 'Bidhaa',
    'vendor.tabs.analytics': 'Uchambuzi',
    'vendor.tabs.managers': 'Wasimamizi',
    'vendor.applications': 'Maombi ya wauzaji',
    'vendor.vendor_list': 'Orodha ya wauzaji',
    'vendor.candidate': 'Mgombea',
    'vendor.company': 'Kampuni',
    'vendor.type': 'Aina',
    'vendor.examine': 'Chunguza',
    'vendor.product': 'Bidhaa',
    'vendor.vendor': 'Muuzaji',
    'vendor.stock': 'Hifadhi',
    'vendor.creation_date': 'Tarehe ya uundaji',
    
    // Configuration
    'admin.config.categories.general': 'Jumla',
    'admin.config.categories.general_desc': 'Mipangilio ya jumla ya tovuti',
    'admin.config.site_info': 'Taarifa za tovuti',
    'admin.config.site_name': 'Jina la tovuti',
    'admin.config.platform_name': 'Jina kuu la jukwaa lako',
    'admin.config.tagline': 'Kauli mbiu',
    'admin.config.tagline_desc': 'Maelezo mafupi ya jukwaa lako',
    'admin.config.description': 'Maelezo',
    'admin.config.description_desc': 'Maelezo ya kina kwa SEO',
    'admin.config.logo_images': 'Nembo na picha',
    'admin.config.logo_url': 'Nembo ya tovuti',
    'admin.config.logo_url_desc': 'URL ya nembo',
    'admin.config.hero_image': 'Picha ya sehemu ya hero',
    'admin.config.hero_image_desc': 'URL ya picha kuu ya ukurasa wa nyumbani',
    'admin.config.contact_support': 'Mawasiliano na msaada',
    'admin.config.contact_email': 'Barua pepe ya mawasiliano',
    'admin.config.contact_email_desc': 'Anuani ya barua pepe kuu',
    'admin.config.support_phone': 'Simu ya msaada',
    'admin.config.support_phone_desc': 'Nambari ya simu ya msaada kwa wateja',
    'admin.config.maintenance_mode': 'Hali ya matengenezo',
    'admin.config.maintenance_mode_desc': 'Washa hali ya matengenezo ya tovuti',
    'admin.config.show_announcement_banner': 'Onyesha bango la tangazo',
    'admin.config.show_announcement_banner_desc': 'Onyesha au ficha bango la rangi ya machungwa juu ya tovuti (inafanya kazi hata katika hali ya matengenezo)',
    'admin.config.password_reset_expiry': 'Muda wa kiungo cha kubadilisha nywila',
    'admin.config.password_reset_expiry_desc': 'Muda wa uhalali wa viungo vya kubadilisha nywila (kwa dakika, kati ya 5 na 1440)',
    'admin.config.footer': 'Footer',
    'admin.config.footer_address': 'Anwani',
    'admin.config.footer_address_desc': 'Anwani ya kuonyesha kwenye footer',
    'admin.config.footer_copyright': 'Maandishi ya hakimiliki',
    'admin.config.footer_copyright_desc': 'Maandishi ya hakimiliki chini ya ukurasa',
    'admin.config.footer_facebook': 'Kiungo cha Facebook',
    'admin.config.footer_facebook_desc': 'URL ya ukurasa wako wa Facebook',
    'admin.config.footer_twitter': 'Kiungo cha Twitter/X',
    'admin.config.footer_twitter_desc': 'URL ya akaunti yako ya Twitter',
    'admin.config.footer_instagram': 'Kiungo cha Instagram',
    'admin.config.footer_instagram_desc': 'URL ya akaunti yako ya Instagram',
    'admin.config.appearance': 'Muonekano',
    'admin.config.appearance_desc': 'Badilisha muonekano',
    'admin.config.theme_colors': 'Mandhari na rangi',
    'admin.config.primary_color': 'Rangi ya msingi',
    'admin.config.primary_color_desc': 'Rangi kuu ya chapa yako',
    'admin.config.secondary_color': 'Rangi ya pili',
    'admin.config.secondary_color_desc': 'Rangi ya pili kwa rangi za ziada',
    'admin.config.dark_mode': 'Hali ya giza',
    'admin.config.dark_mode_desc': 'Ruhusu kubadilisha hali ya giza',
    'admin.config.ui': 'Kiolesura cha mtumiaji',
    'admin.config.border_radius': 'Radius ya mpaka',
    'admin.config.border_radius_desc': 'Rekebisha duara la vipengele (px)',
    'admin.config.animation_speed': 'Kasi ya uhuishaji',
    'admin.config.animation_speed_desc': 'Kasi ya mabadiliko (ms)',
    'admin.config.payment': 'Malipo',
    'admin.config.payment_desc': 'Usanidi wa malipo',
    'admin.config.payment_methods': 'Njia za malipo',
    'admin.config.stripe_enabled': 'Stripe imewashwa',
    'admin.config.stripe_enabled_desc': 'Washa malipo ya kadi ya Stripe',
    'admin.config.mobile_money': 'Pesa ya Simu',
    'admin.config.mobile_money_desc': 'Washa malipo ya pesa ya simu',
    'admin.config.cash_on_delivery': 'Malipo wakati wa kupokea',
    'admin.config.cash_on_delivery_desc': 'Ruhusu malipo wakati wa kupokea',
    'admin.config.fees': 'Usanidi wa ada',
    'admin.config.transaction_fee': 'Ada ya muamala (%)',
    'admin.config.transaction_fee_desc': 'Asilimia inayochukuliwa kwa kila mauzo',
    'admin.config.min_order': 'Kiasi cha chini cha agizo',
    'admin.config.min_order_desc': 'Kiasi cha chini kuweka agizo (CDF)',
    'admin.config.payment_simulation': 'Uigaji wa malipo (test)',
    'admin.config.payment_country_simulation_enabled': 'Washa uigaji wa nchi',
    'admin.config.payment_country_simulation_enabled_desc': 'Lazimisha nchi ya majaribio kwa upangaji wa malipo (admin tu)',
    'admin.config.payment_country_simulation_country': 'Nchi ya kuigiza',
    'admin.config.payment_country_simulation_country_desc': 'Chagua nchi ya kuigiza (mfano: CD kujaribu Flutterwave)',
    'admin.config.shipping': 'Usafirishaji',
    'admin.config.shipping_desc': 'Mipangilio ya usafirishaji',
    'admin.config.shipping_options': 'Chaguo za usafirishaji',
    'admin.config.default_shipping_cost': 'Gharama ya kawaida ya usafirishaji',
    'admin.config.default_shipping_cost_desc': 'Bei ya kawaida ya usafirishaji (CDF)',
    'admin.config.free_shipping_threshold': 'Kizingiti cha usafirishaji bure',
    'admin.config.free_shipping_threshold_desc': 'Kiasi cha usafirishaji bure (CDF)',
    'admin.config.delivery_days': 'Muda wa uwasilishaji',
    'admin.config.delivery_days_desc': 'Idadi ya siku kwa uwasilishaji wa kawaida',
    'admin.config.notifications': 'Arifa',
    'admin.config.notifications_desc': 'Simamia arifa',
    'admin.config.email_notifications': 'Arifa za barua pepe',
    'admin.config.email_enabled': 'Arifa za barua pepe',
    'admin.config.email_enabled_desc': 'Tuma arifa za barua pepe',
    'admin.config.order_confirmation': 'Uthibitisho wa agizo',
    'admin.config.order_confirmation_desc': 'Barua pepe ya uthibitisho baada ya agizo',
    'admin.config.shipping_notification': 'Arifa ya usafirishaji',
    'admin.config.shipping_notification_desc': 'Barua pepe wakati wa kusafirisha',
    'admin.config.sms_notifications': 'Arifa za SMS',
    'admin.config.sms_enabled': 'Arifa za SMS',
    'admin.config.sms_enabled_desc': 'Tuma arifa za SMS',
    'admin.config.security': 'Usalama',
    'admin.config.security_desc': 'Mipangilio ya usalama',
    'admin.config.authentication': 'Uthibitishaji',
    'admin.config.email_verification': 'Uthibitishaji wa barua pepe unahitajika',
    'admin.config.email_verification_desc': 'Lazima uthibitishaji wa barua pepe wakati wa kusajili',
    'admin.config.password_length': 'Urefu wa chini wa nenosiri',
    'admin.config.password_length_desc': 'Idadi ya chini ya herufi',
    'admin.config.session_timeout': 'Muda wa kikao (dakika)',
    'admin.config.session_timeout_desc': 'Muda kabla ya kutoka kiotomatiki',
    'admin.config.save_all': 'Hifadhi mipangilio yote',
    'admin.config.reset': 'Rudisha',
    'admin.config.preview': 'Onyesho la awali',
    'admin.config.changes_saved': 'Mipangilio imehifadhiwa',
    'admin.config.changes_saved_desc': 'Mipangilio yote imesasishwa kwa mafanikio',
    'admin.config.settings_updated': 'Mpangilio umesasishwa',
    'admin.config.error_loading': 'Imeshindwa kupakia mipangilio',
    'admin.config.error_saving': 'Imeshindwa kuhifadhi mipangilio',
    'admin.config.reset_confirm': 'Mipangilio imerudishwa',
    'admin.config.reset_confirm_desc': 'Mipangilio ya chaguo-msingi imerejeshwa',
    'admin.config.no_logo': 'Hakuna nembo',
    'admin.config.no_logo_desc': 'Tafadhali sanidi URL ya nembo kwanza',
    'admin.config.download_started': 'Upakuaji umeanza',
    'admin.config.download_started_desc': 'Nembo inapakua',
    'admin.payment_fees.title': 'Ada za malipo',
    'admin.payment_fees.description': 'Sanidi ada zinazotumika kwa njia ya malipo',
    'admin.payment_fees.stripe': 'Ada za Stripe (%)',
    'admin.payment_fees.mobile': 'Ada za Pesa ya Simu (%)',
    'admin.payment_fees.stripe_desc': 'Ada zinazotumika kwa malipo ya kadi ya Stripe',
    'admin.payment_fees.mobile_desc': 'Ada zinazotumika kwa Orange Money, Airtel Money, M-Pesa',
    'admin.payment_fees.example': 'Mfano',
    'admin.payment_fees.on': 'kwenye',
    'admin.payment_fees.save': 'Hifadhi ada',
    'admin.payment_fees.saving': 'Inahifadhi...',
    'admin.payment_fees.updated': 'Ada zimesasishwa',
    'admin.payment_fees.updated_desc': 'Ada za malipo zimehifadhiwa kwa mafanikio',
    'admin.payment_fees.error': 'Imeshindwa kuhifadhi ada',
    'admin.payment_fees.loading': 'Inapakia...',

    // API Keys Management
    'admin.api_keys.title': 'Usimamizi wa Funguo za API',
    'admin.api_keys.description': 'Simamia funguo za API na siri za huduma zote za nje',
    'admin.api_keys.tab': 'API',
    'admin.api_keys.stripe': 'Stripe',
    'admin.api_keys.resend': 'Resend',
    'admin.api_keys.firebase': 'Firebase',
    'admin.api_keys.apns': 'Apple Push Notification',
    'admin.api_keys.environment': 'Mazingira',
    'admin.api_keys.test': 'Jaribio',
    'admin.api_keys.live': 'Hai',
    'admin.api_keys.active_env': 'Mazingira yanayotumika',
    'admin.api_keys.switch_env': 'Badilisha mazingira',
    'admin.api_keys.public_key': 'Funguo la Umma',
    'admin.api_keys.secret_key': 'Funguo la Siri',
    'admin.api_keys.webhook_secret': 'Siri ya webhook',
    'admin.api_keys.api_key': 'Funguo la API',
    'admin.api_keys.service_account': 'Service Account JSON',
    'admin.api_keys.private_key': 'Funguo la Binafsi',
    'admin.api_keys.key_id': 'Key ID',
    'admin.api_keys.team_id': 'Team ID',
    'admin.api_keys.show': 'Onyesha',
    'admin.api_keys.hide': 'Ficha',
    'admin.api_keys.copy': 'Nakili',
    'admin.api_keys.copied': 'Imenakiliwa',
    'admin.api_keys.copied_desc': 'Funguo limenakiliwa kwenye clipboard',
    'admin.api_keys.save': 'Hifadhi mabadiliko',
    'admin.api_keys.saving': 'Inahifadhi...',
    'admin.api_keys.saved': 'Funguo zimehifadhiwa',
    'admin.api_keys.saved_desc': 'Funguo za API zimehifadhiwa kwa mafanikio',
    'admin.api_keys.cancel': 'Ghairi',
    'admin.api_keys.invalid_format': 'Muundo batili',
    'admin.api_keys.invalid_format_desc': 'Muundo wa funguo ni batili',
    'admin.api_keys.security_warning': 'Onyo la Usalama',
    'admin.api_keys.security_desc': 'Funguo za API zinahifadhiwa kwa usalama. Usishiriki funguo zako za uzalishaji.',
    'admin.api_keys.admin_only': 'Wasimamizi pekee wanaweza kuona na kubadilisha funguo hizi',
    'admin.api_keys.env_changed': 'Mazingira yamebadilishwa',
    'admin.api_keys.env_changed_desc': 'Mazingira yanayotumika yamebadilishwa',
    'admin.api_keys.placeholder.stripe_public': 'pk_test_... au pk_live_...',
    'admin.api_keys.placeholder.stripe_secret': 'sk_test_... au sk_live_...',
    'admin.api_keys.placeholder.stripe_webhook': 'whsec_...',
    'admin.api_keys.placeholder.resend': 're_...',
    'admin.api_keys.placeholder.firebase': '{"type":"service_account",...}',
    'admin.api_keys.placeholder.apns_key': '-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----',
    'admin.api_keys.placeholder.apns_key_id': 'ABC123XYZ',
    'admin.api_keys.placeholder.apns_team_id': 'DEF456UVW',

    // Orders
    'admin.orders.recent': 'Maagizo ya hivi karibuni',
    'admin.orders.track': 'Fuatilia maagizo',
    'admin.orders.order': 'Agizo',
    'admin.orders.client': 'Mteja',
    'admin.orders.vendor': 'Muuzaji',
    'admin.orders.amount': 'Kiasi',
    
    // Orders Page
    'orders.title': 'Maagizo yangu',
    'orders.subtitle': 'Fuatilia hali ya maagizo yako yote',
    'orders.back_home': 'Rudi nyumbani',
    'orders.tabs.all': 'Yote',
    'orders.tabs.active': 'Hai',
    'orders.tabs.completed': 'Imekamilika',
    'orders.tabs.cancelled': 'Imeghairiwa',
    'orders.status.PENDING_PAYMENT': 'Inasubiri malipo',
    'orders.status.PAID': 'Imelipwa',
    'orders.status.PREPARING': 'Inaandaliwa',
    'orders.status.READY_FOR_PICKUP': 'Tayari kuchukua',
    'orders.status.AVAILABLE_FOR_PICKUP': 'Iko tayari kuchukua',
    'orders.status.PICKED_UP': 'Imechukuliwa',
    'orders.status.CANCELLED': 'Imeghairiwa',
    'orders.status.EXPIRED': 'Imeisha muda',
    'orders.tracker.created': 'Agizo limewekwa',
    'orders.tracker.paid': 'Malipo yamethibitishwa',
    'orders.tracker.available': 'Iko tayari kuchukuliwa',
    'orders.tracker.picked_up': 'Imechukuliwa',
    'orders.tracker.in_progress': 'Inaendelea...',

    // Footer
    'footer.description': 'Sokoni lako la kuaminiwa huko Kinshasa',
    'footer.quick_links': 'Viungo vya haraka',
    'footer.categories': 'Makundi',
    'footer.contact': 'Mawasiliano',
    'footer.newsletter': 'Jarida',
    'footer.about': 'Kuhusu',
    'footer.how_it_works': 'Jinsi inavyofanya kazi',
    'footer.become_vendor': 'Kuwa muuzaji',
    'footer.relay_points': 'Vituo vya kuchukua',
    'footer.support': 'Msaada',
    'footer.email_placeholder': 'Barua pepe yako',

    // Categories
    'categories.electronics': 'Elektroniki',
    'categories.fashion': 'Mitindo',
    'categories.home': 'Nyumbani',
    'categories.auto': 'Magari',
    'categories.books': 'Vitabu',

    // Hero Section
    'hero.title': 'Nunua hapa karibu, pokea haraka',
    'hero.title.location': 'huko Kinshasa',
    'hero.tagline': 'Soko lako la karibu',
    'hero.description': 'Gundua bidhaa bora za ndani na kimataifa moja kwa moja huko Kinshasa',
    'hero.explore_products': 'Chunguza bidhaa',
    'hero.become_vendor': 'Kuwa muuzaji',
    'hero.fast_delivery': 'Uwasilishaji wa haraka',
    'hero.fast_delivery.desc': 'Pokea maagizo yako haraka',
    'hero.secure_payment': 'Malipo salama',
    'hero.secure_payment.desc': 'Miamala yako inalindwa',
    'hero.easy_pickup': 'Kuchukua rahisi',
    'hero.easy_pickup.desc': 'Vituo vya kuchukua katika jiji zima',
    'hero.secure_order': 'Agizo salama',
    'hero.satisfied_customers': '+1000 wateja wenye furaha',
    
    // Configuration Manager UI
    'admin.config.download': 'Pakua',
    'admin.config.logo_preview': 'Angalia nembo',
    'admin.config.logo_preview_desc': 'Nembo itaonekana kwenye header na footer',
    'admin.config.image_preview': 'Angalia',
    'admin.config.enabled': 'Imewashwa',
    'admin.config.disabled': 'Imezimwa',
    'admin.config.loading': 'Inapakia mipangilio...',
    'admin.config.advanced_title': 'Mipangilio ya juu',
    'admin.config.advanced_desc': 'Rekebisha vipengele vyote vya jukwaa lako',
    'admin.config.unsaved_changes': 'Mabadiliko hayajahifadhiwa',
    'admin.config.saving': 'Inahifadhi...',
    'admin.config.preview_title': 'Angalia mabadiliko',
    'admin.config.preview_desc': 'Ona mabadiliko yako kwa wakati halisi kwenye vifaa tofauti',
    'admin.config.device_desktop': 'Desktop',
    'admin.config.device_tablet': 'Tablette',
    'admin.config.device_mobile': 'Simu',
    'admin.config.simulation': 'Jaribio',
    'admin.config.view_real_site': 'Angalia tovuti halisi',
    'admin.config.refresh': 'Sasisha',
    'admin.config.url_placeholder': 'https://example.com/image.jpg au /image.jpg',
    'admin.config.logo_url_placeholder': 'https://example.com/logo.png au /logo.png'
  }
};